import { livereload } from './app/tools/livereload.js';
import { polyfill } from './app/tools/smoothscroll.js';
polyfill();
livereload();
document.body.addEventListener('mousedown', function() {
		document.querySelector("header").classList.add('using_mouse');
});
	
	// Re-enable focus styling when Tab is pressed
document.body.addEventListener('keydown', function(event) {
	console.log("key",event)
	if (event.code === "Tab") {
		document.querySelector("header").classList.remove('using_mouse');
	}
});
var scrollHandler = (e) => {
	// console.log("scrolling",document.documentElement.scrollTop);
	const scrollTop = document.documentElement.scrollTop;
	document.querySelector("svg g#clouds").style.transform='translateY('+scrollTop/3+'px)';
	try {
		document.querySelector("svg path#landscape-background").style.transform='translateY('+scrollTop/10+'px)';
		document.querySelector("svg path#landscape-foreground").style.transform='translateY('+scrollTop/20+'px)';
		document.querySelector("svg g#business").style.transform='translateY('+scrollTop/40+'px)';
	} catch(e) {}
}
window.addEventListener("scroll",() => window.requestAnimationFrame(scrollHandler));
